import axios from 'axios';
import queryString from 'query-string';
import ky from 'ky';
import * as Sentry from 'utils/errorTracking';

import { getAPI } from 'utils/helpers';
import apiClient from 'lib/apiClient';

export const getFinancialSecurities = ({ name, size, page }) =>
  axios
    .get(
      queryString.stringifyUrl(
        {
          url: `${getAPI()}/secondary/financialSecurity/search`,
          query: {
            page,
            name,
            size,
          },
        },
        {
          skipEmptyString: true,
        },
      ),
    )
    .then(({ data }) => data);

export const getInvestmentAccountRequest = async ({ primaryUserId }) => {
  try {
    const response = await ky(
      `${getAPI()}/secondary/investmentAccount?primaryUserId=${primaryUserId}`,
    ).json();
    return response;
  } catch (error) {
    Sentry.captureException(error);
    // eslint-disable-next-line no-console
    console.error('Failed to get investment account:', error);
    throw error;
  }
};

export const getCompanies = (page, size) => {
  return apiClient.get(
    queryString.stringifyUrl(
      {
        url: `${getAPI()}/secondary/secure`,
        query: {
          page,
          size,
        },
      },
      {
        skipEmptyString: true,
      },
    ),
  );
};

export const getCache = ({ key }) => {
  return axios.get(`${getAPI()}/cache/get/${key}`);
};

export const setCache = (data) => {
  return axios.post(`${getAPI()}/cache/set`, data);
};

export const getAgreementStatusRequest = async (accountId) => {
  try {
    const response = await apiClient.get(
      `${getAPI()}/secondary/investmentAccount/${accountId}/agreement/actions`,
    );
    return response.data;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
};

export const getLatestAgreementRequest = async () => {
  try {
    const response = await axios.get(
      `${getAPI()}/secondary/agreement/type/SE_SUBSCRIBER_AGREEMENT/latest`,
    );
    return response.data;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
};

export const getAccreditationEligibility = async ({ primaryUserId }) => {
  try {
    const response = await ky(`${getAPI()}/secondary/person/accreditation/eligibility`, {
      searchParams: { primaryUserId },
    }).json();
    return response;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
};

export const submitAgreementRequest = async (investmentAccountId, agreementId, data) => {
  try {
    const response = await apiClient.post(
      `${getAPI()}/secondary/investmentAccount/${investmentAccountId}/subscriberAgreement/${agreementId}/actions/sign`,
      data,
    );
    return response.data;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
};
